import { createContext } from 'react'

interface FCMContextProps {
  registerFCM: () => Promise<void>
  unregisterFCM: () => Promise<void>
}

const FCMContext = createContext<FCMContextProps>({
  registerFCM: async () => { },
  unregisterFCM: async () => { }
})

export default FCMContext